"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabs = exports.StyledDivider = exports.StyledContainer = exports.Root = exports.classes = void 0;
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const styles_1 = require("@mui/material/styles");
const container_1 = __importDefault(require("../container"));
const PREFIX = "Tabs";
exports.classes = {
    tabRoot: `${PREFIX}-tabRoot`,
    tabPanel: `${PREFIX}-tabPanel`,
    tabIndicator: `${PREFIX}-tabIndicator`,
    tabPanelBox: `${PREFIX}-tabPanelBox`,
    tabsBar: `${PREFIX}-tabsBar`,
    secondary: `${PREFIX}-secondary`,
    visibleUntillg: `${PREFIX}-visibleUntillg`,
    visibleUntilmd: `${PREFIX}-visibleUntilmd`,
    iconWrapper: `${PREFIX}-iconWrapper`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    ".MuiTabs-flexContainer": {
        paddingRight: "3px" // prevents scroll button overflow
    },
    [`.${exports.classes.tabRoot}`]: {
        fontSize: "1rem",
        minWidth: "initial",
        padding: "6px 15px",
        path: {
            fill: theme.colours.slate
        },
        "&:hover": {
            color: theme.colours.charcoal,
            [`.${exports.classes.iconWrapper}`]: {
                path: {
                    fill: theme.colours.charcoal
                }
            }
        },
        "&.Mui-selected": {
            color: theme.colours.accent,
            path: {
                fill: theme.colours.accent
            },
            "&:hover": {
                color: theme.colours.focus,
                [`.${exports.classes.iconWrapper}`]: {
                    path: {
                        fill: theme.colours.focus
                    }
                }
            }
        }
    },
    [`.${exports.classes.tabPanel}`]: {
        "&[hidden]": {
            position: "absolute",
            top: "-9999px",
            left: "-99999px",
            width: "100%",
            display: "block"
        }
    },
    [`.${exports.classes.tabPanelBox}`]: {
        background: theme.colours.white,
        padding: "24px 24px 0 0"
    },
    [`.${exports.classes.tabsBar}`]: {
        backgroundColor: theme.colours.white,
        fontSize: "1.25rem",
        position: "relative",
        flexGrow: "1",
        [theme.breakpoints.up("lg")]: {
            flexGrow: "0"
        }
    },
    [`&.${exports.classes.secondary}`]: {
        [`.${exports.classes.tabsBar}`]: {
            backgroundColor: theme.colours.pearl,
            borderBottom: `1px solid ${theme.colours.storm}`,
            borderTop: `1px solid ${theme.colours.storm}`,
            [theme.breakpoints.up("sm")]: {
                border: "none"
            }
        }
    },
    [`&.${exports.classes.visibleUntillg}`]: {
        [theme.breakpoints.up("lg")]: {
            display: "flex",
            [`.${exports.classes.tabsBar}`]: {
                display: "none"
            },
            [`.${exports.classes.tabPanel}, .${exports.classes.tabPanelBox}`]: {
                display: "initial",
                "&[hidden]": {
                    position: "initial",
                    left: 0,
                    top: 0
                }
            }
        }
    },
    [`&.${exports.classes.visibleUntilmd}`]: {
        [theme.breakpoints.up("md")]: {
            display: "flex",
            [`.${exports.classes.tabsBar}`]: {
                display: "none"
            },
            [`.${exports.classes.tabPanel}, .${exports.classes.tabPanelBox}`]: {
                display: "initial",
                "&[hidden]": {
                    position: "initial",
                    left: 0,
                    top: 0
                }
            }
        }
    },
    [`.${exports.classes.iconWrapper}`]: {
        marginRight: "14px",
        display: "flex",
        svg: {
            width: "20px"
        }
    }
}));
exports.StyledContainer = (0, styles_1.styled)(container_1.default)({
    fontSize: "1rem",
    paddingLeft: "0 !important",
    paddingRight: "0 !important"
});
exports.StyledDivider = (0, styles_1.styled)(Divider_1.default)(({ theme }) => ({
    [theme.breakpoints.up("lg")]: {
        alignSelf: "flex-end",
        display: "block",
        flexGrow: "1",
        marginBottom: "2px"
    }
}));
exports.StyledTabs = (0, styles_1.styled)(Tabs_1.default)(({ theme }) => ({
    fontSize: "1rem",
    maxWidth: "100%",
    ".tabsScrollBtn": {
        position: "absolute",
        height: "100%",
        zIndex: 2,
        background: theme.colours.white,
        transition: "all 0.2s ease-out",
        "&:first-of-type": {
            left: 0,
            opacity: 1
        },
        "&:last-child": {
            right: 0,
            opacity: 1
        },
        "&.Mui-disabled": {
            opacity: 0,
            transition: "all 0.2s ease-out"
        }
    },
    [theme.breakpoints.down("sm")]: {
        maxWidth: "400px"
    },
    [theme.breakpoints.down("md")]: {
        maxWidth: "600px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RhYnMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLG9FQUE0QztBQUM1Qyw4REFBOEM7QUFDOUMsaURBQThDO0FBQzlDLDZEQUFxQztBQUVyQyxNQUFNLE1BQU0sR0FBRyxNQUFNLENBQUM7QUFFVCxRQUFBLE9BQU8sR0FBRztJQUNyQixPQUFPLEVBQUUsR0FBRyxNQUFNLFVBQVU7SUFDNUIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0lBQzlCLFlBQVksRUFBRSxHQUFHLE1BQU0sZUFBZTtJQUN0QyxXQUFXLEVBQUUsR0FBRyxNQUFNLGNBQWM7SUFDcEMsT0FBTyxFQUFFLEdBQUcsTUFBTSxVQUFVO0lBQzVCLFNBQVMsRUFBRSxHQUFHLE1BQU0sWUFBWTtJQUNoQyxjQUFjLEVBQUUsR0FBRyxNQUFNLGlCQUFpQjtJQUMxQyxjQUFjLEVBQUUsR0FBRyxNQUFNLGlCQUFpQjtJQUMxQyxXQUFXLEVBQUUsR0FBRyxNQUFNLGNBQWM7Q0FDckMsQ0FBQztBQUVXLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNoRCxRQUFRLEVBQUUsVUFBVTtJQUNwQix3QkFBd0IsRUFBRTtRQUN4QixZQUFZLEVBQUUsS0FBSyxDQUFDLGtDQUFrQztLQUN2RDtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsT0FBTyxFQUFFLENBQUMsRUFBRTtRQUN2QixRQUFRLEVBQUUsTUFBTTtRQUNoQixRQUFRLEVBQUUsU0FBUztRQUNuQixPQUFPLEVBQUUsVUFBVTtRQUNuQixJQUFJLEVBQUU7WUFDSixJQUFJLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1NBQzFCO1FBQ0QsU0FBUyxFQUFFO1lBQ1QsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtZQUM3QixDQUFDLElBQUksZUFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7Z0JBQzNCLElBQUksRUFBRTtvQkFDSixJQUFJLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRO2lCQUM3QjthQUNGO1NBQ0Y7UUFDRCxnQkFBZ0IsRUFBRTtZQUNoQixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNO1lBQzNCLElBQUksRUFBRTtnQkFDSixJQUFJLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNO2FBQzNCO1lBQ0QsU0FBUyxFQUFFO2dCQUNULEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7Z0JBQzFCLENBQUMsSUFBSSxlQUFPLENBQUMsV0FBVyxFQUFFLENBQUMsRUFBRTtvQkFDM0IsSUFBSSxFQUFFO3dCQUNKLElBQUksRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7cUJBQzFCO2lCQUNGO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3hCLFdBQVcsRUFBRTtZQUNYLFFBQVEsRUFBRSxVQUFVO1lBQ3BCLEdBQUcsRUFBRSxTQUFTO1lBQ2QsSUFBSSxFQUFFLFVBQVU7WUFDaEIsS0FBSyxFQUFFLE1BQU07WUFDYixPQUFPLEVBQUUsT0FBTztTQUNqQjtLQUNGO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxXQUFXLEVBQUUsQ0FBQyxFQUFFO1FBQzNCLFVBQVUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDL0IsT0FBTyxFQUFFLGVBQWU7S0FDekI7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLE9BQU8sRUFBRSxDQUFDLEVBQUU7UUFDdkIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUNwQyxRQUFRLEVBQUUsU0FBUztRQUNuQixRQUFRLEVBQUUsVUFBVTtRQUNwQixRQUFRLEVBQUUsR0FBRztRQUNiLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixRQUFRLEVBQUUsR0FBRztTQUNkO0tBQ0Y7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLFNBQVMsRUFBRSxDQUFDLEVBQUU7UUFDMUIsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1lBQ3ZCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7WUFDcEMsWUFBWSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUU7WUFDaEQsU0FBUyxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUU7WUFDN0MsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO2dCQUM1QixNQUFNLEVBQUUsTUFBTTthQUNmO1NBQ0Y7S0FDRjtJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsY0FBYyxFQUFFLENBQUMsRUFBRTtRQUMvQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7WUFDNUIsT0FBTyxFQUFFLE1BQU07WUFDZixDQUFDLElBQUksZUFBTyxDQUFDLE9BQU8sRUFBRSxDQUFDLEVBQUU7Z0JBQ3ZCLE9BQU8sRUFBRSxNQUFNO2FBQ2hCO1lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxRQUFRLE1BQU0sZUFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7Z0JBQ2pELE9BQU8sRUFBRSxTQUFTO2dCQUNsQixXQUFXLEVBQUU7b0JBQ1gsUUFBUSxFQUFFLFNBQVM7b0JBQ25CLElBQUksRUFBRSxDQUFDO29CQUNQLEdBQUcsRUFBRSxDQUFDO2lCQUNQO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxjQUFjLEVBQUUsQ0FBQyxFQUFFO1FBQy9CLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixPQUFPLEVBQUUsTUFBTTtZQUNmLENBQUMsSUFBSSxlQUFPLENBQUMsT0FBTyxFQUFFLENBQUMsRUFBRTtnQkFDdkIsT0FBTyxFQUFFLE1BQU07YUFDaEI7WUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLFFBQVEsTUFBTSxlQUFPLENBQUMsV0FBVyxFQUFFLENBQUMsRUFBRTtnQkFDakQsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFdBQVcsRUFBRTtvQkFDWCxRQUFRLEVBQUUsU0FBUztvQkFDbkIsSUFBSSxFQUFFLENBQUM7b0JBQ1AsR0FBRyxFQUFFLENBQUM7aUJBQ1A7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7UUFDM0IsV0FBVyxFQUFFLE1BQU07UUFDbkIsT0FBTyxFQUFFLE1BQU07UUFDZixHQUFHLEVBQUU7WUFDSCxLQUFLLEVBQUUsTUFBTTtTQUNkO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsZUFBZSxHQUFHLElBQUEsZUFBTSxFQUFDLG1CQUFTLENBQUMsQ0FBQztJQUMvQyxRQUFRLEVBQUUsTUFBTTtJQUNoQixXQUFXLEVBQUUsY0FBYztJQUMzQixZQUFZLEVBQUUsY0FBYztDQUM3QixDQUFDLENBQUM7QUFFVSxRQUFBLGFBQWEsR0FBRyxJQUFBLGVBQU0sRUFBQyxpQkFBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixTQUFTLEVBQUUsVUFBVTtRQUNyQixPQUFPLEVBQUUsT0FBTztRQUNoQixRQUFRLEVBQUUsR0FBRztRQUNiLFlBQVksRUFBRSxLQUFLO0tBQ3BCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFZLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDN0QsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFFaEIsZ0JBQWdCLEVBQUU7UUFDaEIsUUFBUSxFQUFFLFVBQVU7UUFDcEIsTUFBTSxFQUFFLE1BQU07UUFDZCxNQUFNLEVBQUUsQ0FBQztRQUNULFVBQVUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDL0IsVUFBVSxFQUFFLG1CQUFtQjtRQUMvQixpQkFBaUIsRUFBRTtZQUNqQixJQUFJLEVBQUUsQ0FBQztZQUNQLE9BQU8sRUFBRSxDQUFDO1NBQ1g7UUFDRCxjQUFjLEVBQUU7WUFDZCxLQUFLLEVBQUUsQ0FBQztZQUNSLE9BQU8sRUFBRSxDQUFDO1NBQ1g7UUFDRCxnQkFBZ0IsRUFBRTtZQUNoQixPQUFPLEVBQUUsQ0FBQztZQUNWLFVBQVUsRUFBRSxtQkFBbUI7U0FDaEM7S0FDRjtJQUVELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM5QixRQUFRLEVBQUUsT0FBTztLQUNsQjtJQUVELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM5QixRQUFRLEVBQUUsT0FBTztLQUNsQjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=